<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="feedbackTemplateList || []"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.CustomerFeedback") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <!-- <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create' })"
                size="small"
                >{{ $t("setup.label.AddFeedback") }}</vs-button
              > -->
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.TicketId") }}</vs-th>
            <vs-th>{{ $t("setup.label.CoustomerId") }}</vs-th>
            <vs-th>{{ $t("setup.label.CustomerName") }}</vs-th>
            <vs-th>{{ $t("setup.label.SubCategory") }}</vs-th>
            <Vs-th>{{ $t("setup.label.FeedbackStatus") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="feed" v-for="(feed, index) in data">
              <vs-td>{{ feed.ticketId }}</vs-td>
              <vs-td>{{ feed.customerId }}</vs-td>
              <vs-td>{{ feed.customerName }}</vs-td>
              <vs-td>{{ feed.subcategoryName }}</vs-td>
              <vs-td>{{ feed.feedbackStatus }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="openView(feed)"
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      // feedbackList: (state) => state.qna.feedbackList,
      formattedDate: (state) => state.settings.selectedDateFormat,
      feedbackList: (state) => state.ticket.ticketListData,
      feedbackTemplateList: (state) => state.ticket.feedbackTemplateInfo,
    }),
  },
  methods: {
    async getFeedbackQuesListMethod() {
      this.loading = true;
      try {
        await this.$store.dispatch("qna/getFeedbackQuesListAction");
      } catch (e) {
        this.$toasted.error(e, {
          duration: 2000,
        });
      }
      this.loading = false;
    },
      openView(feed) {
  if (feed.feedbackStatus && feed.feedbackStatus.toUpperCase() === "SENT")
    this.$swal({
      title: "Error",
      text: "This feedback has not been submitted yet",
      icon: "error",
      confirmButtonText: "OK",
    });

  if (feed.feedbackStatus && feed.feedbackStatus.toUpperCase() === "RESPONDED") {
    this.$router.push({
      name: "View Customer Feedback",
      params: { 
        id: feed.id, 
        ticketId: feed.ticketId, 
        clientName: feed.clientName 
      },
    });
  }
},
    async getFeedbackList() {
      try {
        this.disabled = true;
        await this.$store.dispatch("ticket/fetchFeedbackTemplate");
        this.disabled = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    // await this.getFeedbackQuesListmethod();
    await this.getFeedbackList();
  },
};
</script>
